import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import SiteDetailCenter from "./SiteDetailCenter"; // Points to the web layout page

const SiteDetailCenterWrapper = () => {
    const { projectId, projectName } = useParams(); const navigate = useNavigate();
    console.log(projectId);
    // Safely capture parameters passed during redirect click action


    // Redirection guard to fall back if page is loaded directly without project selection state
    if (!projectId) {
        return (
            <div className="p-20 text-center space-y-4">
                <p className="font-black uppercase text-xs text-slate-400 tracking-widest">No active location selection detected</p>
                <button
                    onClick={() => navigate("/")}
                    className="bg-slate-900 text-white font-black text-[10px] uppercase tracking-widest px-6 py-3 rounded-xl"
                >
                    Return to Project Index
                </button>
            </div>
        );
    }

    return (
        <SiteDetailCenter
            projectId={projectId}
            projectName={projectName}
            onBack={() => navigate(-1)}
        />
    );
};

export default SiteDetailCenterWrapper;